class StickyCategories {
  static async init () {
    return new StickyCategories()
  }

  constructor () {
    this.$el = $('.sticky-categories')

    if (this.$el.length === 0) {
      return
    }

    this.parentWidth = this.$el.parent().width()
    this.offsetTop = this.$el.offset().top

    this.handleScrollEvent()
    this.bindEvents()
  }

  bindEvents () {
    $(window).on('scroll', this.handleScrollEvent.bind(this))
  }

  handleScrollEvent () {
    const scrollTop = $(window).scrollTop()

    if (scrollTop > this.offsetTop) {
      this.$el
        .addClass('sticky-section')
        .width(this.parentWidth)
        .removeClass('my-3')
    } else {
      this.$el
        .removeClass('sticky-section')
        .width('auto')
        .addClass('my-3')
    }
  }
}

export default StickyCategories
